<div class="row">
  <div class="card">
    <div class="card-body bg-white">
      <div *ngIf="this.loader" class="spinner-border"
           role="status" style="z-index: 100;position: fixed;margin-top: 20%;margin-left: 15%;margin-right: auto;">
        <span class="visually-hidden">Loading...</span>
      </div>
      <form (ngSubmit)="onSubmit(accountform.value,'form')" [formGroup]="accountform">

        <div class="row">
          <!-- <div class="col-sm-6">
            <div class="mb-3">
             
              <label class="form-label">Entity ID <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
            

              <ng-select (click)="loadDatabyMid()" (keyup.enter)="loadDatabyMid()" formControlName="merchantId"
                         id="merchantId" placeholder="merchantId">
                <ng-option *ngFor="let merchant of Resdata" [value]="merchant.MerchantId" id="selectedOption">
                  {{merchant.merchant_name}} ({{merchant.MerchantId}})
                </ng-option>
              </ng-select>
            </div>
          </div> -->
  
<!-- 
         <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">Product ID <span aria-hidden="true" class="symbol required"
                                                       style="color:red;">*</span></label>
            <input    (keypress)="keyPressAlphaNumeric($event)" [ngClass]="{'is-invalid': isForm1Submitted && form1.productId.errors}" autocomplete="new-password"
                   class="form-control" formControlName="productId" id="productId" placeholder="Product ID"
                   type="text" maxlength="20" minlength="2"
                   (keypress)="OnlyNumbersAllowed($event)">
            <div *ngIf="isForm1Submitted && form1.productId.errors?.required" class="invalid-feedback">
              Please Enter Product ID
            </div>
            <div *ngIf="isForm1Submitted && form1.productId.errors?.minlength" class="invalid-feedback">
              Please Enter Minimum Length 2
            </div>
          </div>
        </div> -->

        </div><!-- Row -->
        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3 d-flex align-items-end">
              <div style="flex:1;">
                <label class="form-label">RIB<span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
                <input [readonly]="editableCheck" autocomplete="new-password" class="form-control" formControlName="iBan"
                       id="iBan" (keypress)="OnlyCharacterNumberAllowed($event)"
                       placeholder="RIB" type="text">
                       <!-- [ngClass]="{'is-invalid': isForm1Submitted && form1.iBan.errors}" -->
                <!-- <div *ngIf="isForm1Submitted && form1.iBan.errors?.required" class="invalid-feedback">
                  Please Enter IBAN
                </div>
                <div *ngIf="isForm1Submitted && form1.iBan.errors?.pattern" class="invalid-feedback">
                  Please Enter Valid IBAN
                </div>
                <div *ngIf="isForm1Submitted && form1.iBan.errors?.minlength" class="invalid-feedback">
                  Please Enter Minimum Length 23
                </div> -->
              </div>
              <!-- <button *ngIf="!editableCheck && !editEnable" type="button" class="btn btn-outline-secondary ms-2 mb-1" (click)="validateIban()">Validate IBAN</button> -->
            </div>
          </div>
          <!-- <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Currency<span aria-hidden="true" class="symbol required"
                                                            style="color:red;">*</span></label>
              <input [ngClass]="{'is-invalid': isForm1Submitted && form1.curreny.errors}" autocomplete="new-password" readonly class="form-control" formControlName="curreny"
                     id="curreny"
                     placeholder="Currency" type="text">
              <div *ngIf="isForm1Submitted && form1.curreny.errors?.required" class="invalid-feedback">
                Please Enter Currency
              </div>
              <div *ngIf="isForm1Submitted && form1.curreny.errors?.pattern" class="invalid-feedback">
                Please Enter Valid Currency
              </div>
            </div>
          </div> -->



          <div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">
      Currency
      <span aria-hidden="true" class="symbol required" style="color:red;">*</span>
    </label>

    <input
      class="form-control"
      formControlName="curreny"
      id="curreny"
      placeholder="Enter Currency"
      type="text"
      autocomplete="off"
      readonly
    >
  </div>
</div>


          <!-- <div class="col-sm-6 row" style="margin-top: 5%;">
            <div class="col-md-2">
              <i *ngIf="isverify=='Y'&&this.verifyButton" class="feather icon-check-circle icon-lg"
                 style="color: green;"></i>
            </div>
          </div> -->
        </div>

        <div class="row">

          <!-- <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Bank Name<span aria-hidden="true" class="symbol required"
                                                             style="color:red;">*</span>&nbsp; <i
                *ngIf="isverify=='Y'&&this.verifyButton" class="feather icon-check-circle icon-lg"
                style="color: green;"></i></label>
              <input (keypress)="OnlyNumbersAllowed($event)" (paste)="false" (keydown.space)="$event.preventDefault()"
                     [ngClass]="{'is-invalid': isForm1Submitted && form1.nostroAccount.errors}"
                     autocomplete="new-password" class="form-control" formControlName="nostroAccount" id="nostroAccount"
                     maxlength="25" minlength="8" placeholder="Bank Nostro A / C Details"
                     type="number">

              <div *ngIf="Ress">
               <i class="feather icon-check-circle icon-lg" style="color: green;"></i>
              </div> 
              <div *ngIf="isForm1Submitted && form1.accountNumber.errors?.required" class="invalid-feedback">
                Please Enter Bank Name
              </div>
              <div *ngIf="isForm1Submitted && form1.accountNumber.errors?.minlength" class="invalid-feedback">
                Please Enter Valid Bank Name
              </div>
              <div *ngIf="form1.accountNumber.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
              <div *ngIf="!accountNumberdis" class="text-danger mt-1 err">
                {{ accountNumberError }}
              </div>
              
            </div>
          </div> -->


          <!-- <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Bank Name <span aria-hidden="true" class="symbol required"
                                                                    style="color:red;">*</span></label>
              <input (paste)="false" readonly [ngClass]="{'is-invalid': isForm1Submitted && form1.bankName.errors}" autocomplete="new-password" class="form-control" formControlName="bankName"

                     id="bankName" maxlength="50" minlength="2"
                     placeholder="Bank Name" type="text">
           

              <div *ngIf="isForm1Submitted && form1.bankName.errors?.required" class="invalid-feedback">
                Please Enter Bank Name
              </div>

              <div *ngIf="isForm1Submitted && form1.bankName.errors?.pattern"
                   class="invalid-feedback">
                Please Enter Valid Bank Name
              </div>
              <div *ngIf="form1.bankName.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>


          </div>
           -->


<div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">
      Bank Name
      <span aria-hidden="true" class="symbol required" style="color:red;">*</span>
    </label>

    <input
      
      class="form-control"
      formControlName="bankName"
      id="bankName"
      placeholder="Enter Bank Name"
      type="text"
      autocomplete="off"
    >
  </div>
</div>

          
          <!-- Col -->
          <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">Account Title<span aria-hidden="true" class="symbol required"
                                                                  style="color:red;">*</span></label>
            <input (paste)="false"  [ngClass]="{'is-invalid': isForm1Submitted && form1.accountTitle.errors}" autocomplete="new-password" class="form-control" formControlName="accountTitle"
                   id="accountTitle" maxlength="50" minlength="2"
                   placeholder="Account Title" type="text">
            <!-- <div *ngIf="Ress">
              <i class="feather icon-check-circle icon-lg" style="color: green;"></i>
             </div> -->

            <div *ngIf="isForm1Submitted && form1.accountTitle.errors?.required" class="invalid-feedback">
              Please Enter Account Title
            </div>

            <!-- <div *ngIf="isForm1Submitted && form1.accountTitle.errors?.pattern"
                 class="invalid-feedback">
              Please Enter Valid Account Title
            </div> -->
            <div *ngIf="form1.accountTitle.errors?.twoSpaces" class="invalid-feedback">
              More than two consecutive spaces are not allowed
            </div>
          </div>
          </div>

        </div><!-- Row -->

        <div class="row">

          <!-- <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Account Number <span aria-hidden="true" class="symbol required"
                                                             style="color:red;">*</span>&nbsp; <i
                *ngIf="isverify=='Y'&&this.verifyButton" class="feather icon-check-circle icon-lg"
                style="color: green;"></i></label>
              <input (keypress)="OnlyNumbersAllowed($event)" (paste)="false" (keydown.space)="$event.preventDefault()"
                     [ngClass]="{'is-invalid': isForm1Submitted && form1.accountNumber.errors}"
                     autocomplete="new-password" class="form-control" formControlName="accountNumber" id="accountNumber"
                     maxlength="25" minlength="8" placeholder="Account Number"
                     type="number"> -->

              <!-- <div *ngIf="Ress">
               <i class="feather icon-check-circle icon-lg" style="color: green;"></i>
              </div> -->

<!-- 
              <div *ngIf="isForm1Submitted && form1.accountNumber.errors?.required" class="invalid-feedback">
                Please Enter Account Number
              </div>
              <div *ngIf="isForm1Submitted && form1.accountNumber.errors?.minlength" class="invalid-feedback">
                Please Enter Valid Account Number
              </div>
              <div *ngIf="form1.accountNumber.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
              <div *ngIf="!accountNumberdis" class="text-danger mt-1 err">
                {{ accountNumberError }}
              </div>
              
            </div>


          </div> -->
            


        </div><!-- Row -->
        <!-- <div class="row" >
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Intermediary Bank Swift<span aria-hidden="true" class="symbol required"
                                                        style="color:red;">*</span> &nbsp;
              </label>
              <input
                (keypress)="OnlyCharacterNumberAllowed($event)"
                [(ngModel)]="IFSCValue" [ngClass]="{'is-invalid': isForm1Submitted && form1.intermediaryBankSwift.errors}" autocomplete="new-password" class="form-control"
                formControlName="intermediaryBankSwift"
                id="intermediaryBankSwift" maxlength="11"
                placeholder="Intermediary Bank Swift" type="text">
              <label *ngIf="IFSCData" class="text-muted p-1 small" style="text-align: left;">
                {{IFSCData | titlecase}}
              </label>
              <div *ngIf="isForm1Submitted && form1.intermediaryBankSwift.errors?.required" class="invalid-feedback">
                Please Enter Intermediary Bank Swift
              </div>
              <div *ngIf="isForm1Submitted && form1.intermediaryBankSwift.errors?.pattern" class="invalid-feedback">
                Please Enter Valid Intermediary Bank Swift
              </div>
              <div *ngIf="form1.intermediaryBankSwift.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>

            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Intermediary Bank<span aria-hidden="true" class="symbol required"
                                                        style="color:red;">*</span></label>
             

              <input (focus)="fun('bankName')" (focusout)="funover('bankName')" (keypress)="OnlyCharacterAllowed($event)"
                         [ngClass]="{'is-invalid': isForm1Submitted && form1.intermediaryBank.errors}"
                         formControlName="intermediaryBank" id="intermediaryBank"
                         placeholder="Intermediary Bank" required class="form-control"/>
              <div *ngIf="isForm1Submitted && form1.intermediaryBank.errors?.required" class="invalid-feedback">
                Please Enter Intermediary Bank
              </div>
            </div>
          </div> 
        </div> -->

        <!-- <div class="row" >
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Bank Address<span aria-hidden="true" class="symbol required"
                                                                    style="color:red;">*</span></label>
              <input (keypress)="OnlyCharacterAllowed($event)" [ngClass]="{'is-invalid': isForm1Submitted && form1.bankAddress.errors}" autocomplete="new-password" class="form-control"
                     formControlName="bankAddress"
                     id="bankAddress"
                     maxlength="70" placeholder="Bank Address" type="text">
              <label *ngIf="AccountUserName" class="text-muted p-1 small" style="text-align: left;">
                {{AccountUserName | titlecase}}
              </label>
              <div *ngIf="isForm1Submitted && form1.bankAddress.errors?.required" class="invalid-feedback">
                Please Enter Bank Address
              </div>
              <div *ngIf="form1.bankAddress.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label">Swift Code<span aria-hidden="true" class="symbol required"
                                                            style="color:red;">*</span></label>
              <input (keypress)="OnlyCharacterNumberAllowed($event)" [ngClass]="{'is-invalid': isForm1Submitted && form1.swiftCode.errors}" autocomplete="new-password" class="form-control"
                     formControlName="swiftCode"
                     id="swiftCode"
                     maxlength="10" placeholder="Swift Code" type="text">
              <div *ngIf="isForm1Submitted && form1.swiftCode.errors?.required" class="invalid-feedback">
                Please enter Swift Code
              </div>

              <div *ngIf="isForm1Submitted && form1.swiftCode.errors?.pattern" class="invalid-feedback">
                Please enter Valid Swift Code
              </div>
            </div>
          </div>

        </div> -->


        <div class="row mb-2">
          <div class="col-xs-12">
            <div class="text-end" *ngIf="editEnable">
              <button *ngIf="this.permissions.includes('Add')" class="btn btn-primary pull-right"
                      type="button" (click)="editButton()">
                Edit
              </button>
            </div>
            <div class="text-end" *ngIf="!editEnable">
              <!-- <button (click)="validateAccount(accountform.value)" [disabled]="!(this.permissions.includes('Add') || this.permissions.includes('Edit')) || this.isverify =='Y'||this.loading" class="btn btn-primary pull-right"
                      type="button">
                <span aria-hidden="true" id="loading" role="status"></span>
                Validate
              </button> -->
                  <!-- <button *ngIf="this.permissions.includes('Add')" class="btn btn-primary pull-right"
                      type="submit" [disabled]="!isIbanValidated"> -->
              <button *ngIf="this.permissions.includes('Add')" class="btn btn-primary pull-right"
                      type="submit" >
                <span aria-hidden="true" id="submitloading" role="status"></span>
                Submit
              </button>
              <button *ngIf="this.permissions.includes('Add')" class="btn btn-primary pull-right"
                      type="button" (click)="cancelButton()">
                Cancel
              </button>
              
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</div>

<div class="row mb-md-2 mt-2"  *ngIf="false">
  <div class="col-xl-10 main-content">
    <button (click)="onExportCSV()" class="btn btn-primary" type="button">Export CSV<i class="feather icon-download"></i>
    </button>
    <div class="btn-group" ngbDropdown role="group">
      <button class="btn btn-primary" ngbDropdownToggle>Columns</button>
      <div class="ng-dropdown-panel-items p-1" ngbDropdownMenu
           style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
        <div class="form-group">
          <!--            <label for="columns" class="form-label"> All Columns</label>-->
          <div *ngIf="columnDefs" class="list-group ng-option">
            <span *ngFor="let column of columnDefs; let i = index" class="checkbox">
              <label class="list-group-item p-2">
                <input (change)="updateSelectedTimeslots($event)" [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" class="form-check-input me-1" name="{{column.headerName}}"
                       type="checkbox" style="margin-left: 180px;"
                       value="{{i}}">
                {{column?.field?.replace('_', ' ')?.replace('_', ' ')?.replace('_', ' ') | uppercase }}
              </label>
            </span>
          </div>

        </div>
        <!--          <ng-select-->
        <!--            [(ngModel)]="tableSelectedColumn"-->
        <!--            [closeOnSelect]="false"-->
        <!--            [items]="columnDefs"-->
        <!--            [multiple]=true-->
        <!--            bindLabel="field">-->
        <!--            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>-->
        <!--              <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}-->
        <!--            </ng-template>-->
        <!--          </ng-select>-->

      </div>
    </div>
    <!--
        <div class="btn-group mb-1 mb-md-0">
          <button class="btn btn-primary" type="button">Columns</button>
          <div class="btn-group" ngbDropdown role="group">
            <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
            <div ngbDropdownMenu>
              <ng-select [(ngModel)]="tableSelectedColumn" [closeOnSelect]="false" [items]="columnDefs" [multiple]=true
                         bindLabel="field">
                <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                  <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div> -->
  </div>
  <div class="col-xl-2">
   <input [(ngModel)]="globalSearch"  class="form-control" 
           id="filter-text-box" placeholder="Search" type="text"  (input)="onFilterTextBoxChanged()"/>
           
           <!-- <input
        type="text"
        id="filter-text-box"
        placeholder="Filter..."
        (input)="onFilterTextBoxChanged()"
      /> -->
  </div>
</div>


<!-- BANK TABLE  -->
<!-- <div class="row" style="min-height: 300px">
  <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
    <ag-grid-angular (filterModified)="onFilterModified($event)"
                     (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)"
                     (rowClicked)="onRowClicked($event)"
                     (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn"
                     [defaultColDef]="defaultColDef"
                     [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
                     [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
                     style="width: 100%; height: auto;"></ag-grid-angular>
  </div>
</div> -->

<div class="row bg-white mt-2">
  <!-- <div class="col-md-4">
    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
      <option [ngValue]="10">10</option>
      <option [ngValue]="20">20</option>
      <option [ngValue]="30">30</option>
    </select>
  </div> -->

  <!-- <div class="col-md-8">
    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
                    [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
                    class="d-flex justify-content-end col-8 align-right">
    </ngb-pagination>
  </div> -->

</div>
